<div class="print-only">
    <div class="modal-body">
        <ng-container #outlet [ngTemplateOutlet]="content">
        </ng-container>
    </div>
</div>

<ng-template #content>
    <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@500&display=swap" rel="stylesheet">
    <div id="{{targetId}}" class="container">
        <div *ngFor="let page of pages; let pageIndex = index" class="qr-page" [style.page-break-after]="pageIndex < pages.length - 1 ? 'always' : 'auto'">
            <div *ngFor="let row of page" class="qr-row">
                <div *ngFor="let student of row" class="qr-student-card">
                    <img src="/assets/logo_bw.png" height="60" class="qr-logo">
                    <div class="qr-student-name">
                        {{student.StudentName}}
                    </div>
                    <div class="qr-class-name">{{student.ClassName}}</div>
                    <qrcode [qrdata]="getQRData(student)" [scale]="3" [margin]="2"></qrcode>
                </div>
            </div>
        </div>
    </div>
</ng-template>
  
<app-loading-spinner *ngIf="loading && !hideButton" [noMargin]="true" [text]="''"></app-loading-spinner>
<span (click)="printDiv()" class="ml-4" ngbTooltip="Print QR Codes" *ngIf="!loading && !hideButton">
    <i class="fas fa-qrcode pointer"></i>
</span>